import { render, staticRenderFns } from "./student-list-for-moeys.vue?vue&type=template&id=57b8acda&"
import script from "./student-list-for-moeys.vue?vue&type=script&lang=js&"
export * from "./student-list-for-moeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports